import axios from 'services/http';
import { baseUrl } from 'services/http/base';

export const getExchangeRate = async <T>() => {
  return axios.post<T>(`${baseUrl}/sapi/v1/exchange_rate/rates`);
};
